module.exports = __webpack_public_path__ + "img/horizontal_4_3_9006.98ba36dc.png";